module.exports = __webpack_public_path__ + "img/uk-real-estate-residential.10b11db8.jpg";